import React from 'react';
import { useDispatch, useSelector } from "react-redux";

import { authReset } from "../../../store/API/actions";
import { ApplicationState } from "../../../store";
import './style.css';
import parse from 'html-react-parser';


const AuthFailedComponent = () => {
    const { authErrorMsg, authErrorTitle } = useSelector((state: ApplicationState) => state.API);
    const dispatch = useDispatch();

    const onReturnToLoginPage = () => dispatch(authReset());

    const parsedMsg = parse(authErrorMsg ? authErrorMsg : '');
    
    return (
        <div className='auth-failed'>
            <h2 className='auth-failed-title'>{ authErrorTitle }</h2>
            <h3 className='auth-failed-message'>
                { parsedMsg }
            </h3>
            <div className='flex js-c'>
                <button className='auth-btn'
                        onClick={() => onReturnToLoginPage()}
                >
                    Back
                </button>
            </div>
        </div>
    )
};

export default AuthFailedComponent